import { DirectiveOptions } from "vue";
import { DirectiveBinding } from "vue/types/options";

function setPosition(element: HTMLElement, binding: DirectiveBinding) {
    element.style.position = "fixed";
    element.style.top = (window.innerHeight * 0.36) + "px";
    element.style.width = (window.innerWidth * 0.062) + "px";
    element.style.left = (window.innerWidth * 0.250) + "px";
    }

const workshops: DirectiveOptions = {
    inserted(el, binding) {
        setPosition(el, binding);
    },
    update(el, binding) {
        setPosition(el, binding);
    }
};

export default workshops;
